<div class="container-fluid h-100 readOnlyForm pl-0 pr-0">

  <!-- Section header start -->
  <div class="headerBackground card p-1 mb-2 tool-header-height">
    <div class="row padding2px">
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 sectionHeaderIcon">
        <span>
          <!-- <fa-icon class="fas "  
            [icon]="faCircle">
          </fa-icon> -->
          <fa-icon class="fas fa-lg autoCursor" title="click for smart checklist" (click)="openSmartChecklist()"
            [icon]="faLifeRing"></fa-icon>
        </span>
      </div>
      <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-4">
        <h6 class="headerFontSize">Entity test</h6>
      </div>
      <div class="col col-7 col-md-7 col-lg-7 col-sm-7 col-xs-6">
        <p class="titleParagraph">TEST AN ENTITY.<br>
          Analyse, understand, design & evaluate.
        </p>
      </div>
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1">
        <table class="dropGroupBtn">
          <tr>
            <td rowspan="2">
              <!-- <span>
                <a type="button" (click)="selectedEntityIDDetails && openChatGPTassist('ET-LS')">
                  <fa-icon class="fas fa-lg toolLogoYellow" [icon]="faLightbulb" title="intelligent assistant"></fa-icon>
                </a>
              </span> -->
            </td>
            <td rowspan="2">

            </td>
            <td rowspan="2">
              <span>
                <a type="button" (click)="selectedEntityIDDetails && generateMindMap()">
                  <fa-icon class="fas fa-lg" [icon]="faSitemap" title="mindmap"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <!-- <span class="autoCursor ">
                <fa-icon class="fas fa-lg extraIcon" [icon]="faFileExport" title="report"></fa-icon>
              </span> -->
            </td>
          </tr>

        </table>
      </div>
    </div>
  </div>
  <!-- Section header end -->
  <div class="environ-designer tool-body-height">
    <div class="card p-1 mb-2 bg-white borderNone h-97">
      <div class="row full-width p-0">
        <div class="col-sm-2 col-xs-2 btn-padding">
          <div class="row strict radio-button">
            <div class="dropdown">
              <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                type="button" data-toggle="dropdown">
                <div class="row strict">
                  <div class="col-xs-10">
                    <span>{{selectedmodule.mName}}
                    </span>
                  </div>
                  <div class="col-xs-1 col-xs-offset-1 pull-right ">
                    <span class="caret"></span>
                  </div>
                </div>
              </button>
              <ul class="dropdown-menu deepDriveEntityDropdown">
                <li class="row strict cursorPointer" *ngFor="let mod of modelData.modules">
                  <div class="col-xs-11 col-xs-offset-1  dropdown-item" (click)="selectModule(mod)">
                    {{mod.mName}}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-sm-1 col-xs-1 btn-padding">
          <div class="dropdown">
            <button class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px"
              type="button" data-toggle="dropdown" [ngClass]="{ dis:EntityType}">
              <div class="row strict">
                <div class="col-xs-7 span-on-button ">
                  <span>
                    {{choosenType | translate}}
                  </span>
                </div>
                <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                  <span class="caret"></span>
                </div>
              </div>
            </button>
            <ul class="dropdown-menu text-color-black w-25 scrollable-menu">
              <li class="row padding-vertical pl-2 pr-2" *ngFor="let type of types" (click)="chooseType(type)">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 dropdown-item">
                  {{type}}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-sm-1 col-xs-1 btn-padding">
          <div class="dropdown">
            <button class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px"
              type="button" data-toggle="dropdown" [ngClass]="{ dis:EntityType}">
              <div class="row strict">
                <div class="col-xs-7 span-on-button ">
                  <span>
                    {{choosenEntityType | translate}}
                  </span>
                </div>
                <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                  <span class="caret"></span>
                </div>
              </div>
            </button>
            <ul class="dropdown-menu text-color-black w-25 scrollable-menu">
              <li class="row padding-vertical pl-2 pr-2" *ngFor="let eType of entityTypes" (click)="chooseeType(eType)">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 dropdown-item">
                  {{eType}}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-xs-6 btn-padding pl-0 pr-2">
          <div class="dropdown">
            <button class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px"
              type="button" data-toggle="dropdown" [ngClass]="{ dis:primaryEntity}">
              <div class="row strict">
                <div class="col-xs-7 span-on-button ">
                  <span>
                    {{choosenPrimaryeName || 'landscape.chooseBaseEntity' | translate}}
                  </span>
                </div>
                <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                  <span class="caret"></span>
                </div>
              </div>
            </button>
            <ul class="dropdown-menu text-color-black w-100 scrollable-menu">
              <span>
                <li (click)="choosePrimaryEUT('')">&nbsp; anonymous</li>
              </span>
              <span *ngFor="let eut of modelData.listOfBaseEUTs">
                <li class="row padding-vertical pl-2 pr-2" (click)="choosePrimaryEUT(eut)"
                  *ngIf="eut.mID == selectedmodule.mID">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 dropdown-item">
                    {{eut.eName}}
                  </div>
                </li>
              </span>
            </ul>
          </div>

        </div>

        <div class="col-xs-2 btn-padding pr-0">
          <div class="row strict" *ngIf="currentTab != 'execute'">
            <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
              <div>
                <button type="button" (click)="AddNewEUT(true)"
                  class="btn btn-default btn-block btn-sm labelReadOnly paddingtop3px paddingbottom3px">
                  <fa-icon class="fas icon-black" [icon]="faPlus"></fa-icon>
                </button>
              </div>
            </div>
            <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
              <div>
                <button type="button"
                  class="btn btn-block btn-default btn-sm labelReadOnly paddingtop3px paddingbottom3px"
                  (click)="updatedEntity()">
                  <fa-icon class="fas icon-black" [icon]="faEdit"></fa-icon>
                </button>
              </div>
            </div>
            <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
              <div *ngIf="showText == false">
                <button type="button" data-toggle="modal" data-target="#EUTDeleteConfirmModel"
                  class="btn btn-default btn-block btn-sm labelReadOnly paddingtop3px paddingbottom3px">
                  <fa-icon class="fas icon-black" [icon]="faTrash"></fa-icon>
                </button>
              </div>
              <div *ngIf="showText == true">
                <button type="button" (click)="clear()"
                  class="btn btn-default btn-block btn-sm labelReadOnly paddingtop3px paddingbottom3px">
                  <fa-icon class="fas icon-black" [icon]="faTimes"></fa-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="row strict" *ngIf="currentTab == 'execute'">
            <div class="col-xs-6 space-separable">
              <input type="text" class="form-control input-sm paddingtop3px paddingbottom3px" [(ngModel)]="build"
                (blur)="selectBuild(build)" [placeholder]="'validator.buildNo' | translate" ngDefaultControl />
            </div>
            <div class="col-xs-6 space-separable ">
              <div class="dropdown">
                <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                  type="button" data-toggle="dropdown">
                  <div class="row strict">
                    <div class="col-xs-10 text-flow">
                      {{ selectedEnvironment || 'validator.envButton' | translate }}
                    </div>
                    <div class="col-xs-1 col-xs-offset-1 pull-right ">
                      <span class="caret"></span>
                    </div>
                  </div>
                </button>

                <ul class="dropdown-menu dropdown-menu-right">
                  <li *ngIf="modelData.envMap.length <= 0">
                    <div class="alert alert-warning">
                      <strong>{{ 'validator.emptyEnv' | translate }}</strong>
                    </div>
                  </li>
                  <li class="row strict" (click)="chooseEnvironment(en.name)" *ngFor="let en of envMapArrayList">
                    <div class="col-xs-11 col-xs-offset-1 dropdown-item" title={{en.value}}>
                      {{ en.name }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="padding: 0px !important;">
        <div *ngIf="showText == false" class="dropdown">
          <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px" type="button"
            data-toggle="dropdown">
            <div class="row strict">
              <div class="col-xs-10 span-on-button ">
                <span *ngIf="modelData.listOfEUTs.length > 0"><span
                    *ngIf="selectedEntityIDDetails">{{choosenEUT.eName}}</span>
                  <span *ngIf="!selectedEntityIDDetails">{{'deepDive.chooseEntityButton' |
                    translate}}</span>
                </span>
              </div>
              <div class="col-xs-1 col-xs-offset-1 pull-right ">
                <span class="caret"></span>
              </div>
            </div>
          </button>
          <ul class="dropdown-menu" *ngIf="modelData.listOfEUTs.length > 0">
            <li *ngFor="let eut of modelData.listOfEUTs|moduleEntityListFilter:selectedmodule:filterTypeList:searchText"
              (click)="loadEntityDetails(eut)">
              <a>{{eut.eName}}</a>
            </li>
          </ul>
        </div>
        <div *ngIf="showText == true">
          <input type="text" (keyup.enter)="addEntityNew()" [placeholder]="'entityTest.addEntity'|translate"
            [(ngModel)]="newEUTname" id="entitytextarea"
            class="form-control strict lg-input pl-3 pr-3 suites-inputfield">
        </div>
      </div>
      <div class="row strict">
        <ul class="nav nav-tabs">
          <li class="active" (click)="changeTab('description')">
            <a data-toggle="tab" class="textClrWhite" ng-attr-data-target="#descriptionTab">Describe <fa-icon
                class="fas" [icon]="faChevronRight"></fa-icon></a>
          </li>
          <li (click)="changeTab('landscaper')">
            <a data-toggle="tab" class="textClrWhite" ng-attr-data-target="#landscaperTab">Landscape <fa-icon
                class="fas" [icon]="faChevronRight"></fa-icon><fa-icon class="fas float-right cursorPointer toolLogoYellow"
                (click)="selectedEntityIDDetails && openChatGPTassist('ET-LS')" [icon]="faLightbulb"
                title="intelligent assistant"></fa-icon></a>
          </li>
          <li (click)="changeTab('maps')">
            <a data-toggle="tab" id="designerActiveTab" class="textClrWhite" ng-attr-data-target="#mapsTab">Map <fa-icon
                class="fas" [icon]="faChevronRight"></fa-icon><fa-icon class="fas float-right cursorPointer toolLogoYellow"
                (click)="selectedEntityIDDetails && openChatGPTassist('ET-LS')" [icon]="faLightbulb"
                title="intelligent assistant"></fa-icon></a>
          </li>
          <li (click)="changeTab('specs')">
            <a data-toggle="tab" class="textClrWhite" ng-attr-data-target="#specsTab">Deep dive <fa-icon class="fas"
                [icon]="faChevronRight"></fa-icon><fa-icon class="fas float-right cursorPointer toolLogoYellow"
                (click)="selectedEntityIDDetails && openChatGPTassist('ET-DD')" [icon]="faLightbulb"
                title="intelligent assistant"></fa-icon></a>
          </li>
          <li (click)="changeTab('design')">
            <a data-toggle="tab" class="textClrWhite" ng-attr-data-target="#designTab">Design 1 <fa-icon class="fas"
                [icon]="faChevronRight"></fa-icon><fa-icon class="fas float-right cursorPointer toolLogoYellow"
                (click)="selectedEntityIDDetails && openChatGPTassist('ET-DE')" [icon]="faLightbulb"
                title="intelligent assistant"></fa-icon></a>
          </li>
          <li (click)="changeTab('scenarios');scenariosStatus();resetFilters()">
            <a data-toggle="tab" class="textClrWhite" ng-attr-data-target="#scenariosTab">Design 2 <fa-icon class="fas"
                [icon]="faChevronRight"></fa-icon>
              <fa-icon class="fas cursorPointer marginLeft30 float-right toolLogoYellow" (click)="selectedEntityIDDetails && openChatGPTassist('ET-DE')"
                [icon]="faLightbulb" title="intelligent assistant"></fa-icon>
              <fa-icon class="far fa-lg marginleft10 cursorPointer" title="Non covered"
                *ngIf="entityScenarioNill == true" [icon]="faCircle"></fa-icon>
              <fa-icon class="far fa-lg marginleft10 cursorPointer" title="Some covered"
                *ngIf="entityScenarioOne == true" [icon]="faTimesCircle"></fa-icon>
              <fa-icon class="far fa-lg marginleft10 cursorPointer" title="All covered"
                *ngIf="entityScenarioAll == true" [icon]="faCheckCircle"></fa-icon>
            </a>
          </li>
          <li (click)="changeTab('execute');resetFilters()">
            <a data-toggle="tab" class="textClrWhite" ng-attr-data-target="#executeTab">Execute <fa-icon class="fas"
                [icon]="faChevronRight"></fa-icon><fa-icon class="fas cursorPointer marginLeft30 float-right toolLogoYellow" (click)="selectedEntityIDDetails && openChatGPTassist('ET-DE')"
                [icon]="faLightbulb" title="intelligent assistant"></fa-icon></a>
          </li>
        </ul>
      </div>
      <div class="tab-content test-designer-nav-tab-content-height card">
        <div ng-attr-id="descriptionTab" [ngClass]="{ 'active':currentTab==='description'}"
          class="tab-pane fade in h-95">
          <div class="row strict h-100">
            <div class="h-100">
              <fieldset
                class="scheduler-border margin-top02em card cardExplore p-1 mb-2 bg-white h-100 deepdivePopover">
                <legend class="scheduler-border">{{ 'deepDive.ddNotesHeader' | translate }}</legend>
                <div id="box" class="box iconRight" tabindex="0" data-trigger="focus" autocomplete="off"
                  data-html="true" role="button" data-toggle="popover" data-placement="left"
                  [title]="'deepDive.ddNotesHeaderTip' | translate">
                </div>
                <div class="control-group fieldset-text-box-height paddingtop7px">
                  <div class="row strict h-100">
                    <div class="col-xs-12 h-100">
                      <textarea id="DE" rows="1" [(ngModel)]="selectedEntity.bDescription"
                        (focusout)="updateEntityDetails()"
                        class=" form-control transparent square-edge bg-color-black h-100"
                        [placeholder]="'deepDive.ddNotesHeaderPlaceholder'|translate"></textarea>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div ng-attr-id="landscaperTab" [ngClass]="{ 'active':currentTab==='landscaper'}"
          class="tab-pane fade in h-100">
          <div id="designerQuillCSS" class="test-designer-quill-content-height border1pxwhite">
            <quill-editor (onEditorChanged)="editorChanged($event)"
              [placeholder]="'Jot down your observation, suggestion, clarification.'" (onBlur)="blur($event)"
              [(ngModel)]="notesEditorContent">
              <div quill-editor-toolbar>
                <span class="ql-formats">
                  <select class="ql-header"></select>
                  <button class="ql-bold" [title]="'Bold'"></button>
                  <button class="ql-italic" [title]="'Italic'"></button>
                  <button class="ql-underline" [title]="'Underline'"></button>
                  <button class="ql-list" value="ordered"></button>
                  <button class="ql-list" value="bullet"></button>
                  <button class="ql-image" [title]="'Image'"></button>
                </span>
              </div>
            </quill-editor>
          </div>

          <div>
          </div>
        </div>
        <div ng-attr-id="mapsTab" [ngClass]="{ 'active':currentTab==='maps'}" class="tab-pane fade in h-100">
          <div class="row strict h-90 card bg-white">
            <div class="row strict">
              <div class="col-xs-3 space-separable">
                <div class="dropdown" [ngClass]="{ dis:entityName == ''}">
                  <button
                    class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                    type="button" data-toggle="dropdown">
                    <div class="row strict">
                      <div class="col-xs-8 span-on-button">
                        {{ 'deepDive.usedByButtonHeading' | translate }} {{ 'deepDive.personaButton' | translate }}
                      </div>
                      <div class="col-xs-2 pull-right">
                        <span class="caret"></span>
                      </div>
                    </div>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <input class="form-control transparent landscape-input-field" id="personatextarea" rows="1"
                        [placeholder]="'landscape.personaAdd'|translate" (keyup.enter)="addPersona()" autosize="true"
                        ngDefaultControl [(ngModel)]="newPersona" style="background-color : lightyellow !important;">
                    </li>
                    <li class="row strict" *ngFor="let p of modelData.persona">
                      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-1 col-xl-1">
                        <div style="text-align: center;">
                          <input (click)="mapEutToPerson(p.pType,$event.target.checked)" [checked]="isChecked(p.pType)"
                            type="checkbox">
                        </div>
                      </div>
                      <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 col-xl-11 dropdown-item">
                        {{p.pName}}
                      </div>
                    </li>
                  </ul>
                </div>

              </div>
              <div class="col-xs-3 space-separable">
                <div class="dropdown" [ngClass]="{ dis:entityName == ''}">
                  <button
                    class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                    type="button" data-toggle="dropdown">
                    <div class="row strict">
                      <div class="col-xs-8 span-on-button">
                        {{ 'deepDive.toSatisfyButtonHeading' | translate }} {{ 'deepDive.attButton' | translate }}
                      </div>
                      <div class="col-xs-2 pull-right">
                        <span class="caret"></span>
                      </div>
                    </div>

                  </button>
                  <ul class="dropdown-menu">
                    <form>
                      <li class="row strict" *ngFor="let a of config.listOfAttributesUpdated">
                        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-1 col-xl-1">
                          <div style="text-align: center;">
                            <input class="marginleft3px" (click)="mapEutToAtt(a.symbol,$event.target.checked)"
                              [checked]="isCheckedAtt(a)" type="checkbox">
                          </div>
                        </div>
                        <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 col-xl-11 dropdown-item">
                          {{a.name+" ("+a.symbol+")"}}
                        </div>
                      </li>
                    </form>
                  </ul>
                </div>

              </div>
              <div class="col-xs-6 space-separable">
                <div class="dropdown" [ngClass]="{ dis:entityName == ''}">
                  <button
                    class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                    type="button" data-toggle="dropdown">
                    <div class="row strict">
                      <div class="col-xs-8 span-on-button">
                        <!-- {{ 'deepDive.interactsButtonHeading' | translate }} {{ 'deepDive.entityShortFe' | translate }} -->
                        Interacts with/Used by
                      </div>
                      <div class="col-xs-2 pull-right">
                        <span class="caret"></span>
                      </div>
                    </div>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-right w-100">
                    <form>
                      <li>

                        <!-- <div class="row">
                          <div class="col-xs-1 col-sm-1">
                            <select #langSelect   >
                              <option (click)="selectEut('TF')" value="TF">TF</option>
                              <option (click)="selectEut('UR')" value="UR">UR</option>
                              <option (click)="selectEut('BF')" value="BF">BF</option>
                            </select>
                          </div>
                          <div class="col-xs-11 col-sm-11">
                            <textarea class="form-control transparent landscape-input-field" id="personatextarea" (keyup.enter)="addNewEntity()"
                              rows="1" [placeholder]="'entityTest.addEntity'|translate" autosize="true" ngDefaultControl
                              [(ngModel)]="addNewEntityModel" style="background-color : lightyellow !important;"
                              [ngModelOptions]="{standalone: true}">
                          </textarea>
                          </div>
                        </div> -->
                      </li>
                      <li *ngIf="(modelData.listOfEUTs|landscaperEntity:{eType:'TF'}:filterTypeCount) == 0">
                        <div class="alert alert-warning">
                          <strong>{{ 'emptyEntitiesErrors.Fe' | translate }}</strong>
                        </div>
                      </li>
                      <li class="row strict" *ngFor="let eut of modelData.listOfEUTs">
                        <div class="col-xs-2 col-sm-2 col-md-1 col-lg-1 col-xl-1">
                          <div style="text-align: center;" *ngIf="eut.eID != selectedEUT.eID">
                            <input (click)="mapEutToEut(eut.eID,$event.target.checked)" [checked]="isCheckedInter(eut)"
                              type="checkbox">
                          </div>
                        </div>
                        <div class="col-xs-10 col-sm-10 col-md-11 col-lg-11 col-xl-11 dropdown-item">
                          {{this.getModuleName(eut)}} | {{eut.eName}}
                        </div>
                      </li>
                    </form>
                  </ul>
                </div>

              </div>

            </div>
            <div class="row strict deep-dive-fieldset-height">
              <div class="col-xs-12 h-100">
                <textarea class="form-control square-edge bg-color-black disabledFieldDD h-100" [(ngModel)]="mapText"
                  rows="8" disabled></textarea>
              </div>
            </div>
          </div>
        </div>
        <div ng-attr-id="specsTab" [ngClass]="{ 'active':currentTab==='specs'}" class="tab-pane fade in h-100">
          <div class="row padding-vertical h-50">
            <div class="col-xs-6 space-separable h-100">
              <fieldset
                class="scheduler-border margin-top02em card cardExplore p-1 mb-2 bg-white h-100 deepdivePopover">
                <legend class="scheduler-border">{{ 'deepDive.ddBcHeader' | translate }}</legend>
                <div id="box" class="box iconRight" tabindex="0" data-trigger="focus" autocomplete="off"
                  data-html="true" role="button" data-toggle="popover" data-placement="left"
                  [title]="'deepDive.ddBcHeaderTip' | translate">
                </div>
                <div class="control-group fieldset-text-box-height paddingtop7px">
                  <div class="row strict h-100">
                    <div class="col-xs-12 h-100">
                      <textarea class="form-control transparent square-edge bg-color-black h-100"
                        [(ngModel)]="selectedEntity.bc" (focusout)="updateEntityDetails()" rows=" 1" id="BC"
                        [placeholder]="'deepDive.ddBcHeaderPlaceholder'|translate"></textarea>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="col-xs-6 space-separable h-100">
              <div class="h-100">
                <fieldset
                  class="scheduler-border margin-top02em card cardExplore p-1 mb-2 bg-white h-100 deepdivePopover">
                  <legend class="scheduler-border">{{ 'deepDive.ddAcHeader' | translate }}</legend>
                  <div id="box" class="box iconRight" tabindex="0" data-trigger="focus" autocomplete="off"
                    data-html="true" role="button" data-toggle="popover" data-placement="left"
                    [title]="'deepDive.ddAcHeaderTip' | translate">
                  </div>
                  <div class="control-group fieldset-text-box-height paddingtop7px">
                    <div class="row strict h-100">
                      <div class="col-xs-12 h-100">
                        <textarea id="AC" rows="1" [(ngModel)]="selectedEntity.ac" (focusout)="updateEntityDetails()"
                          class=" form-control transparent square-edge bg-color-black h-100"
                          [placeholder]="'deepDive.ddAcHeaderPlaceholder'|translate"></textarea>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>

          <div class="row padding-vertical h-50">
            <div class="col-xs-6 space-separable h-100">
              <fieldset
                class="scheduler-border margin-top02em card cardExplore p-1 mb-2 bg-white h-100 deepdivePopover">
                <legend class="scheduler-border">{{ 'deepDive.ddOutcomeHeader' | translate }}</legend>
                <div id="box" class="box iconRight" tabindex="0" data-trigger="focus" autocomplete="off"
                  data-html="true" role="button" data-toggle="popover" data-placement="left"
                  [title]="'deepDive.ddOutcomeHeaderTip' | translate">
                </div>
                <div class="control-group fieldset-text-box-height paddingtop7px">
                  <div class="row strict h-100">
                    <div class="col-xs-12 h-100">
                      <textarea id="outcomes" rows="1" [(ngModel)]="selectedEntity.outcomes"
                        (focusout)="updateEntityDetails()"
                        class=" form-control transparent square-edge bg-color-black h-100"
                        [placeholder]="'deepDive.ddOutcomeHeaderPlaceholder'|translate"></textarea>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="col-xs-6 space-separable h-100">
              <fieldset
                class="scheduler-border margin-top02em card cardExplore p-1 mb-2 bg-white h-100 deepdivePopover">
                <legend class="scheduler-border">{{ 'deepDive.ddPiHeader' | translate }}</legend>
                <div id="box" class="box iconRight" tabindex="0" data-trigger="focus" autocomplete="off"
                  data-html="true" role="button" data-toggle="popover" data-placement="left"
                  [title]="'deepDive.ddPiHeaderTip' | translate">
                </div>
                <div class="control-group fieldset-text-box-height paddingtop7px">
                  <div class="row strict h-100">
                    <div class="col-xs-12 h-100">
                      <textarea id="pi" rows="1" [(ngModel)]="selectedEntity.pIssues" (focusout)="updateEntityDetails()"
                        class=" form-control transparent square-edge bg-color-black h-100"
                        [placeholder]="'deepDive.ddPiHeaderPlaceholder'|translate"></textarea>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>

        <div ng-attr-id="designTab" [ngClass]="{ 'active':currentTab==='design'}" class="tab-pane fade in h-100">
          <div id="designerQuillCSS" class="test-designer-quill-content-height border1pxwhite">
            <quill-editor (onEditorChanged)="designereditorChanged($event)"
              [placeholder]="'Please write down free form scenarios if any.'  "
              [(ngModel)]="designerNotesEditorContent">
              <div quill-editor-toolbar>
                <span class="ql-formats">
                  <select class="ql-header"></select>
                  <button class="ql-bold" [title]="'Bold'"></button>
                  <button class="ql-italic" [title]="'Italic'"></button>
                  <button class="ql-underline" [title]="'Underline'"></button>
                  <button class="ql-list" value="ordered"></button>
                  <button class="ql-list" value="bullet"></button>
                  <button class="ql-image" [title]="'Image'"></button>
                </span>
              </div>
            </quill-editor>
          </div>

          <div>

            <div class="row full-width pl-4 pr-4">
              <div class="col-xs-4 col-sm-7 col-md-8 col-lg-9 col-xl-9 pr-2">
              </div>
              <div class="col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-2 pl-2 pr-2">
                <div class="form-group">
                  <div class="col-12 pl-0 pr-0">
                    <div class="dropdown up">
                      <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                        type="button" data-toggle="dropdown">
                        <div class="row strict">
                          <div class="col-xs-10 span-on-button">
                            <span>{{selectedTest.name}}</span>
                          </div>
                          <div class="col-xs-1 col-xs-offset-1 pull-right ">
                            <span class="caret"></span>
                          </div>
                        </div>
                      </button>
                      <ul class="dropdown-menu up testDesignerEntityDropdown">
                        <li class="row strict" *ngFor="let Attr of config.listofFunctionalityTestTypes">
                          <div class="col-xs-11 col-xs-offset-1  dropdown-item" (click)="selectTest(Attr)">
                            {{Attr.name}}
                          </div>
                        </li>
                        <li class="row strict" *ngFor="let Attr of config.listOfAttributesUpdated">
                          <div class="col-xs-11 col-xs-offset-1  dropdown-item" (click)="selectTest(Attr)">
                            {{Attr.name}}
                          </div>
                        </li>
                      </ul>
                    </div>

                  </div>
                </div>
              </div>
              <div class="col-xs-2 col-sm-1 col-xl-1 col-lg-1 col-md-1 pr-2 pl-0">
                <button type="button" (click)="checkQuillSelection()"
                  class="btn btn-default btn-block btn-sm float-right paddingtop3px paddingbottom3px">
                  <fa-icon class="fas icon-black" [icon]="faPlus"></fa-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div ng-attr-id="scenariosTab" [ngClass]="{ 'active':currentTab==='scenarios'}" class="tab-pane fade in h-100">
          <div class="row strict h-100 card bg-white">
            <div class="col-xs-12 h-100">
              <div class="row strict scen-border border-none h-100 card bg-white">
                <div class="col-xs-12 h-100">

                  <table id="designerScenTable"
                    class="table table-bordered ui-sort-table table-xs h-100 mb-0 env1 bg-color-black designerScenatioTable">
                    <thead class="w-100">
                      <tr class="row strict border-bottom1px menuItemsClrWhite">
                        <th class="col-sm-1 col-xs-2 border-right1px">
                          <div class="dropdown">
                            <button
                              class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                              type="button" data-toggle="dropdown">
                              <div class="row strict">
                                <div class="col-xs-7 span-on-button">
                                  Level
                                </div>
                                <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu text-color-black w-200 dropdownWidth">
                              <li class="row padding-vertical" *ngFor="let level of config.levels">
                                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                  <div style="text-align: center;">
                                    <input class="checkboxReadOnly cursorPointer"
                                      (click)="addToLevelFilter(level,$event.target.checked)" type="checkbox">
                                  </div>
                                </div>
                                <div
                                  class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item cursorArrow">
                                  {{level}}
                                </div>
                              </li>
                            </ul>
                          </div>

                        </th>
                        <th class="col-sm-1 col-xs-2 border-right1px">
                          <div class="dropdown">
                            <button
                              class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                              type="button" data-toggle="dropdown">
                              <div class="row strict">
                                <div class="col-xs-7 span-on-button">
                                  Test
                                </div>
                                <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu text-color-black w-200 dropdownWidth">
                              <li class="row padding-vertical" *ngFor="let Attr of config.listofFunctionalityTestTypes">
                                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                  <div style="text-align: center;">
                                    <input class="checkboxReadOnly cursorPointer"
                                      (click)="addToAttributeFilter(Attr.symbol,$event.target.checked)" type="checkbox">
                                  </div>
                                </div>
                                <div
                                  class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item cursorArrow">
                                  {{Attr.name}}
                                </div>
                              </li>
                              <li class="row padding-vertical" *ngFor="let Attr of config.listOfAttributesUpdated">
                                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                  <div style="text-align: center;">
                                    <input class="checkboxReadOnly"
                                      (click)="addToAttributeFilter(Attr.symbol,$event.target.checked)" type="checkbox">
                                  </div>
                                </div>
                                <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item">
                                  {{Attr.name}}
                                </div>
                              </li>
                            </ul>
                          </div>

                        </th>
                        <!-- <tr class="row strict border-bottom1px menuItemsClrWhite"> -->
                        <th class="col-sm-1 col-xs-2 border-right1px">
                          <div class="dropdown">
                            <button
                              class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                              type="button" data-toggle="dropdown">
                              <div class="row strict">
                                <div class="col-xs-7 span-on-button">
                                  Type
                                </div>
                                <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu text-color-black w-200 dropdownWidthTesttype">
                              <li class="row padding-vertical" *ngFor="let type of scenarioTypes">
                                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                  <div style="text-align: center;">
                                    <input class="checkboxReadOnly cursorPointer"
                                      (click)="addToCrFilter(type,$event.target.checked)" type="checkbox">
                                  </div>
                                </div>
                                <div
                                  class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item cursorArrow">
                                  {{type}}
                                </div>
                              </li>
                            </ul>
                          </div>

                        </th>

                        <th class="col-sm-9 col-xs-6 border-right1px">
                          <span class="cursorArrow">{{ 'testDesigner.scenarioColumnHeader' | translate }}</span>
                          <fa-icon class="fas addDeleteButtons" style="margin-right: 1px;" [icon]="faRedo" title="clear"
                            (click)="scenarioAddReset()"></fa-icon>&nbsp;
                          <fa-icon class="fas addDeleteButtons" style="margin-right: 7px;" [icon]="faTrash"
                            title="delete" (click)="deleteScenarioModal(editscenariodesc)"></fa-icon>&nbsp;
                          <fa-icon class="fas addDeleteButtons" style="margin-right: 10px;" [icon]="faSave" title="save"
                            (click)="CreateScenario()"></fa-icon>
                        </th>

                      </tr>
                      <tr class="row strict border-bottom1px background-black" auto-crud>
                        <!-- on-create="add('', $index)"
                                on-delete="delete($index)" -->
                        <!-- |filter: checklistName -->
                        <td class="col-sm-1 col-xs-2 no-padding">
                          <div class="dropdown">
                            <button class="btn btn-default btn-sm btn-block dropdown-toggle no-padding" type="button"
                              data-toggle="dropdown">

                              <div class="row strict">
                                <div class="col-xs-12 span-on-button">
                                  <span *ngIf="newscenariolevel!=''">{{newscenariolevel}}
                                  </span>
                                  <span *ngIf="newscenariolevel==''">Level</span>
                                </div>
                                <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu menuItemsClrBlack dropdownWidth">

                              <li class="row strict cursorPointer" *ngFor="let level of config.levels"
                                (click)="selectTest(level)">
                                <div class="col-xs-12 col-xs-offset-1  dropdown-item">
                                  {{level}}
                                </div>
                              </li>

                            </ul>
                          </div>
                        </td>
                        <td class="col-sm-1 col-xs-2 no-padding">
                          <div class="dropdown">
                            <button class="btn btn-default btn-sm btn-block dropdown-toggle no-padding" type="button"
                              data-toggle="dropdown" (click)="updateTestTypeStatus()">

                              <div class="row strict">
                                <div class="col-xs-12 span-on-button">
                                  <span *ngIf="newscenariosymbol!=''">{{newscenariosymbol}}
                                  </span>
                                  <span *ngIf="newscenariosymbol==''">Test Type</span>
                                </div>
                                <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu menuItemsClrBlack dropdownWidthTesttype">
                              <!-- <li class="row strict" *ngFor="let Attr of config.listofFunctionalityTestTypes"
                                (click)="selectTest(Attr)">
                                <div class="col-xs-12 col-xs-offset-1  dropdown-item">
                                  {{Attr.name}}
                                </div>
                              </li> -->
                              <li class="row strict cursorPointer" *ngFor="let Attr of scenarioStatusTestTypes"
                                (click)="selectTest(Attr)">
                                <div class="col-xs-12 col-xs-offset-1  dropdown-item">
                                  <fa-icon class="fas" title="Not specified" *ngIf="!Attr.satisfy"
                                    [icon]="faCircle"></fa-icon>
                                  <fa-icon class="fas icon-black" title="Covered"
                                    *ngIf="(Attr.satisfy == true && Attr.stated == true)"
                                    [icon]="faCheckCircle"></fa-icon>
                                  <fa-icon class="fas icon-black" title="Not covered"
                                    *ngIf="(Attr.satisfy == true && Attr.stated == false)"
                                    [icon]="faTimesCircle"></fa-icon>&nbsp;&nbsp;{{Attr.name}}
                                </div>
                              </li>

                            </ul>
                          </div>
                        </td>
                        <td class="col-sm-1 col-xs-2 no-padding">
                          <div class="dropdown">
                            <button class="btn btn-default btn-sm btn-block dropdown-toggle no-padding" type="button"
                              data-toggle="dropdown">

                              <div class="row strict">
                                <div class="col-xs-12 span-on-button">
                                  <span *ngIf="newscenariocr!=''">{{newscenariocr}}
                                  </span>
                                  <span *ngIf="newscenariocr==''">Type</span>
                                </div>
                                <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu menuItemsClrBlack dropdownWidth">

                              <li class="row strict cursorPointer" *ngFor="let type of scenarioTypes"
                                (click)="selectType(type)">
                                <div class="col-xs-12 col-xs-offset-1  dropdown-item">
                                  {{type}}
                                </div>
                              </li>

                            </ul>
                          </div>
                        </td>

                        <td class="col-sm-9 col-xs-6 no-padding">
                          <!-- textarea shows when user updating or deleting scenario -->
                          <input *ngIf="editScenario.scenID"
                            class="form-control transparent landscape-input-field menuItemsClrBlack" rows="3"
                            [placeholder]="'testDesigner.scenarioModify'|translate" autosize="true"
                            id="designerScenTextarea" [(ngModel)]="editscenariodesc" name="scenarioModifyField"
                            (keyup.enter)="CreateScenario()" style="background-color : lightyellow !important; "
                            ngDefaultControl>

                          <!-- textarea shows when user adding scenario -->
                          <input *ngIf="!editScenario.scenID"
                            class="form-control transparent landscape-input-field menuItemsClrBlack" rows="3"
                            [placeholder]="'testDesigner.scenarioAdd'|translate" autosize="true"
                            id="designerScenTextarea" [(ngModel)]="editscenariodesc" name="scenarioAddField"
                            (keyup.enter)="CreateScenario()" style="background-color : lightyellow !important; "
                            ngDefaultControl>

                        </td>
                      </tr>
                    </thead>
                    <tbody class="scenario-table test-designer-scenarios-table-body-height overflowAuto"
                      [(ngModel)]="modelData.scenarios" *ngIf="selectedEntityeID != ''" ngDefaultControl>
                      <tr class="ui-sortable-item row strict border-bottom1px menuItemsClrWhite clickable-row"
                        *ngFor="let scenario of modelData.scenarios|entitytestscenariofilter:selectedEntityeID:levelSelected:attributeSelected:crSelected:filterTypeList;"
                        (click)="editScenarioData(scenario)">
                        <td class="col-sm-1 col-xs-2 no-padding">{{scenario.attribute.level}}</td>
                        <td class="col-sm-1 col-xs-2 no-padding">{{scenario.attribute.symbol}}</td>
                        <td class="col-sm-1 col-xs-2 no-padding">{{scenario.cr}}</td>
                        <!-- <td class="col-sm-1 col-xs-2 no-padding">
                          {{scenario.cr+"P"+scenario.priority}}
                        </td>
                        <td class="col-sm-1 col-xs-2 no-padding">
                          {{scenario.persona.length}}</td> -->
                        <td class="col-sm-9 col-xs-6 no-padding">{{scenario.description}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div ng-attr-id="scenariosTab" [ngClass]="{ 'active':currentTab==='execute'}" class="tab-pane fade in h-100">
          <div class="row strict h-100 card bg-white">
            <div class="col-xs-12 h-100">
              <div class="row strict scen-border border-none h-100 card bg-white">
                <div class="col-xs-12 h-100">

                  <table id="designerScenTable"
                    class="table table-bordered ui-sort-table table-xs h-100 mb-0 env1 bg-color-black designerScenatioTable">
                    <thead class="w-100">
                      <tr class="row strict border-bottom1px menuItemsClrWhite">
                        <th class="col-sm-1 col-xs-2 border-right1px">
                          <div class="dropdown">
                            <button
                              class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                              type="button" data-toggle="dropdown">
                              <div class="row strict">
                                <div class="col-xs-7 span-on-button text-align-center">
                                  Level
                                </div>
                                <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu text-color-black w-200 dropdownWidth">
                              <li class="row padding-vertical" *ngFor="let level of config.levels">
                                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                  <div style="text-align: center;">
                                    <input class="checkboxReadOnly cursorPointer"
                                      (click)="addToLevelFilter(level,$event.target.checked)" type="checkbox">
                                  </div>
                                </div>
                                <div
                                  class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item cursorArrow">
                                  {{level}}
                                </div>
                              </li>
                            </ul>
                          </div>

                        </th>
                        <th class="col-sm-1 col-xs-2 border-right1px">
                          <div class="dropdown">
                            <button
                              class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                              type="button" data-toggle="dropdown">
                              <div class="row strict">
                                <div class="col-xs-7 span-on-button text-align-center">
                                  Test Type
                                </div>
                                <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu text-color-black w-200 dropdownWidthTesttype">
                              <li class="row padding-vertical" *ngFor="let Attr of config.listofFunctionalityTestTypes">
                                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                  <div style="text-align: center;">
                                    <input class="checkboxReadOnly cursorPointer"
                                      (click)="addToAttributeFilter(Attr.symbol,$event.target.checked)" type="checkbox">
                                  </div>
                                </div>
                                <div
                                  class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item cursorArrow">
                                  {{Attr.name}}
                                </div>
                              </li>
                              <li class="row padding-vertical" *ngFor="let Attr of config.listOfAttributesUpdated">
                                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                  <div style="text-align: center;">
                                    <input class="checkboxReadOnly cursorPointer"
                                      (click)="addToAttributeFilter(Attr.symbol,$event.target.checked)" type="checkbox">
                                  </div>
                                </div>
                                <div
                                  class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item cursorArrow">
                                  {{Attr.name}}
                                </div>
                              </li>
                            </ul>
                          </div>

                        </th>
                        <th class="col-sm-1 col-xs-2 border-right1px">
                          <div class="dropdown">
                            <button
                              class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                              type="button" data-toggle="dropdown">
                              <div class="row strict">
                                <div class="col-xs-7 span-on-button text-align-center">
                                  Type
                                </div>
                                <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu text-color-black w-200 dropdownWidth">
                              <li class="row padding-vertical" *ngFor="let type of scenarioTypes">
                                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                  <div style="text-align: center;">
                                    <input class="checkboxReadOnly cursorPointer"
                                      (click)="addToCrFilter(type,$event.target.checked)" type="checkbox">
                                  </div>
                                </div>
                                <div
                                  class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item cursorArrow">
                                  {{type}}
                                </div>
                              </li>
                            </ul>
                          </div>

                        </th>

                        <th class="col-sm-7 col-xs-4  border-right1px">
                          <span class="cursorArrow">{{ 'testDesigner.scenarioColumnHeader' | translate }}</span>
                          <fa-icon class="fas addDeleteButtons" style="margin-right: 1px;" [icon]="faRedo" title="clear"
                            (click)="scenarioAddReset()"></fa-icon>&nbsp;
                          <fa-icon class="fas addDeleteButtons" style="margin-right: 7px;" [icon]="faTrash"
                            title="delete" (click)="deleteScenarioModal(editscenariodesc)"></fa-icon>&nbsp;
                          <fa-icon class="fas addDeleteButtons" style="margin-right: 10px;" [icon]="faSave" title="save"
                            (click)="CreateScenario()"></fa-icon>
                        </th>
                        <th class="col-sm-1 col-xs-2 border-right1px text-align-center cursorArrow">
                          {{ 'validator.executedHeading' | translate }}
                        </th>
                        <th class="col-sm-1 col-xs-2 no-padding text-align-center cursorArrow">
                          {{ 'validator.outcomeHeading' | translate }}
                        </th>
                      </tr>
                      <tr class="row strict border-bottom1px background-black" auto-crud>
                        <td class="col-sm-1 col-xs-2 no-padding">
                          <div class="dropdown">
                            <button class="btn btn-default btn-sm btn-block dropdown-toggle no-padding" type="button"
                              data-toggle="dropdown">

                              <div class="row strict">
                                <div class="col-xs-12 span-on-button">
                                  <span *ngIf="newscenariolevel!=''">{{newscenariolevel}}
                                  </span>
                                  <span *ngIf="newscenariolevel==''">Level</span>
                                </div>
                                <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu menuItemsClrBlack dropdownWidth">

                              <li class="row strict cursorPointer" *ngFor="let level of config.levels"
                                (click)="selectTest(level)">
                                <div class="col-xs-12 col-xs-offset-1  dropdown-item">
                                  {{level}}
                                </div>
                              </li>

                            </ul>
                          </div>
                        </td>
                        <td class="col-sm-1 col-xs-2 no-padding">
                          <div class="dropdown">
                            <button class="btn btn-default btn-sm btn-block dropdown-toggle no-padding" type="button"
                              data-toggle="dropdown" (click)="updateTestTypeStatus()">

                              <div class="row strict">
                                <div class="col-xs-12 span-on-button">
                                  <span *ngIf="newscenariosymbol!=''">{{newscenariosymbol}}
                                  </span>
                                  <span *ngIf="newscenariosymbol==''">Test Type</span>
                                </div>
                                <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu menuItemsClrBlack dropdownWidthTesttype">
                              <!-- <li class="row strict" *ngFor="let Attr of config.listofFunctionalityTestTypes"
                                (click)="selectTest(Attr)">
                                <div class="col-xs-12 col-xs-offset-1  dropdown-item">
                                  {{Attr.name}}
                                </div>
                              </li> -->
                              <li class="row strict cursorPointer" *ngFor="let Attr of scenarioStatusTestTypes"
                                (click)="selectTest(Attr)">
                                <div class="col-xs-12 col-xs-offset-1  dropdown-item">
                                  <fa-icon class="fas" title="Not specified" *ngIf="!Attr.satisfy"
                                    [icon]="faCircle"></fa-icon>
                                  <fa-icon class="fas icon-black" title="Covered"
                                    *ngIf="(Attr.satisfy == true && Attr.stated == true)"
                                    [icon]="faCheckCircle"></fa-icon>
                                  <fa-icon class="fas icon-black" title="Not covered"
                                    *ngIf="(Attr.satisfy == true && Attr.stated == false)"
                                    [icon]="faTimesCircle"></fa-icon>&nbsp;&nbsp;{{Attr.name}}
                                </div>
                              </li>

                            </ul>
                          </div>
                        </td>
                        <td class="col-sm-1 col-xs-2 no-padding">
                          <div class="dropdown">
                            <button class="btn btn-default btn-sm btn-block dropdown-toggle no-padding" type="button"
                              data-toggle="dropdown">

                              <div class="row strict">
                                <div class="col-xs-12 span-on-button">
                                  <span *ngIf="newscenariocr!=''">{{newscenariocr}}
                                  </span>
                                  <span *ngIf="newscenariocr==''">Type</span>
                                </div>
                                <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu menuItemsClrBlack dropdownWidth">

                              <li class="row strict cursorPointer" *ngFor="let type of scenarioTypes"
                                (click)="selectType(type)">
                                <div class="col-xs-12 col-xs-offset-1  dropdown-item">
                                  {{type}}
                                </div>
                              </li>

                            </ul>
                          </div>
                        </td>

                        <td class="col-sm-7 col-xs-4 no-padding">
                          <!-- textarea shows when user updating or deleting scenario -->
                          <input *ngIf="editScenario.scenID"
                            class="form-control transparent landscape-input-field menuItemsClrBlack" rows="3"
                            [placeholder]="'testDesigner.scenarioModify'|translate" autosize="true"
                            id="designerScenTextarea" [(ngModel)]="editscenariodesc" name="scenarioModifyField"
                            (keyup.enter)="CreateScenario()" style="background-color : lightyellow !important; "
                            ngDefaultControl>

                          <!-- textarea shows when user adding scenario -->
                          <input *ngIf="!editScenario.scenID"
                            class="form-control transparent landscape-input-field menuItemsClrBlack" rows="3"
                            [placeholder]="'testDesigner.scenarioAdd'|translate" autosize="true"
                            id="designerScenTextarea" [(ngModel)]="editscenariodesc" name="scenarioAddField"
                            (keyup.enter)="CreateScenario()" style="background-color : lightyellow !important; "
                            ngDefaultControl>

                        </td>
                        <td class="col-sm-1 col-xs-2 no-padding"></td>
                        <td class="col-sm-1 col-xs-2 no-padding"></td>
                      </tr>
                    </thead>
                    <tbody class="scenario-table test-designer-scenarios-table-body-height overflowAuto"
                      [(ngModel)]="modelData.scenarios" *ngIf="selectedEntityeID != ''" ngDefaultControl>
                      <tr class="ui-sortable-item row strict border-bottom1px menuItemsClrWhite clickable-row"
                        *ngFor="let scenario of modelData.scenarios|entitytestscenariofilter:selectedEntityeID:levelSelected:attributeSelected:crSelected:filterTypeList;">
                        <td class="col-sm-1 col-xs-2 no-padding">{{scenario.attribute.level}}</td>
                        <td class="col-sm-1 col-xs-2 no-padding">{{scenario.attribute.symbol}}</td>
                        <td class="col-sm-1 col-xs-2 no-padding">{{scenario.cr}}</td>
                        <td class="col-sm-7 col-xs-4 no-padding" (click)="editScenarioData(scenario)">
                          {{scenario.description}}</td>
                        <td class="col-sm-1 col-xs-2 no-padding">
                          <fa-icon *ngIf="getStatus(scenario.scenID)=='N'" (click)="updateStatus(scenario.scenID,'Y')"
                            class="far" [icon]="faCircle">
                          </fa-icon>
                          <fa-icon *ngIf="getStatus(scenario.scenID)=='Y'" (click)="updateStatus(scenario.scenID,'N')"
                            class="far" [icon]="faCheckCircle">
                          </fa-icon>
                        </td>
                        <td class="col-sm-1 col-xs-2 no-padding">
                          <div style="text-align: center;">
                            <fa-icon *ngIf="getOutcome(scenario.scenID)==undefined||getOutcome(scenario.scenID)=='P'"
                              (click)="(!build||getStatus(scenario.scenID)=='Y') && updateOutcome(scenario.scenID,'F')"
                              style="color: lightgreen !important" class="fas green" [icon]="faThumbsUp">
                            </fa-icon>
                            <fa-icon *ngIf="getOutcome(scenario.scenID)=='F'"
                              (click)="(!build||getStatus(scenario.scenID)=='Y') && updateOutcome(scenario.scenID,'P')"
                              style="color: red !important" class="fas red" [icon]="faThumbsDown">
                            </fa-icon>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
  <!-- Section footer start -->
  <div class="headerBackground card p-1 mt-2 tool-footer-height">
    <div class='row pb-0 pt-0'>
      <div id="taskplannerTip1" class="carousel slide" data-ride="carousel" data-interval="false">
        <!-- Wrapper for slides -->
        <div class="carousel-inner text-color-yellow">
          <div class="row item active text-color-yellow">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #1 : {{'jiraBugsMapper.tip1' | translate}}
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #2 : {{'jiraBugsMapper.tip2' | translate}}
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #3 : {{'jiraBugsMapper.tip3' | translate}}
            </div>
          </div>
        </div>
        <!-- Left and right controls -->
        <a class="left carousel-control carousel-tip-align display-flex" data-target="#taskplannerTip1"
          data-slide="prev">
          <span>
            <fa-icon class="fas" [icon]="faChevronLeft"></fa-icon>
          </span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control carousel-tip-align display-flex" data-target="#taskplannerTip1"
          data-slide="next">
          <span>
            <fa-icon class="fas" [icon]="faChevronRight"></fa-icon>
          </span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
  <!-- Section footer end -->
</div>

<!-- Test type description respective to entity -->
<div class="modal fade" id="testTypeDescModal" data-backdrop="">
  <div class="vertical-alignment-helper">
    <div class="modal-dialog vertical-align-center">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body">
          <div class="row pb-0">
            <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
            <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="col col-9 col-md-9 col-lg-9 col-sm-9 col-xs-9">
              <div class="form-element mb-0">
                <h3 for="lastname" class="form-label marginbottom6px displayNone">{{selectedTestType.symbol}}</h3>
                <div class="form-element-input">
                  <input type="text" class="form-input-feild input-sm menuItemsClrBlack" rows="2" value=""
                    [(ngModel)]="selectedTestType.desc" [placeholder]="'entityTest.testTypeDesc'|translate" required>
                </div>
              </div>
            </div>
            <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-3">
              <div class="form-element">
                <div class="form-element-input inviteFormElement">
                  <button type="button" class="btn btn-secondary userInvitetoOrgBtn actionbutton pl-0 pr-0"
                    (click)="updateTestTypeDesc()">Save</button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- The persona or entity duplicate error message modal -->
<div class="modal fade" id="duplicateErrorMessagePopupModel" data-backdrop="">
  <div class="vertical-alignment-helper">
    <div class="modal-dialog vertical-align-center">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body">
          <div class="row pb-0">
            <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
            <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
              <div class="form-element text-align-center">
                <label class="form-label marginbottom6px">{{duplicateEntity}}</label>
              </div>
              <div class="form-element text-align-center">
                <label class="form-label marginbottom6px">{{errorMessage}}</label>
              </div>
              <div class="form-element text-align-center">
                <button type="button" id="popupOkbutton"
                  class="btn btn-secondary modalActionBtn orgUserListOkbtn pr-0 pl-0" data-dismiss="modal">{{ 'ok' |
                  translate }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- The EUT delete confirm message modal -->
<div class="modal fade" id="EUTDeleteConfirmModel" data-backdrop="">
  <div class="vertical-alignment-helper">
    <div class="modal-dialog vertical-align-center">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body">
          <div class="row pb-0">
            <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
            <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
              <div class="form-element text-align-center">
                <label class="form-label marginbottom6px">Would you like to delete?</label>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal footer -->
        <div class="modal-footer text-align-center">
          <button type="button" class="btn btn-secondary modalActionBtn marginright10per" (click)="deleteEntity()"
            data-dismiss="modal">{{'yes' | translate}}</button>
          <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">{{'no' |
            translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- The Scenario delete Confirm Message Modal -->
<div class="modal fade" id="deleteScenarioConfirmPopupModel" data-backdrop="">
  <div class="vertical-alignment-helper">
    <div class="modal-dialog vertical-align-center">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body">
          <div class="row pb-0">
            <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
            <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
              <!-- <div class="form-element text-align-center">
						<label class="form-label marginbottom6px contentEllipsis text-align-center"
						  title={{landscape.entityModel.duplicateEntity}}>{{landscape.entityModel.duplicateEntity}}</label>
					  </div> -->
              <div class="form-element text-align-center">
                <label class="form-label marginbottom6px text-align-center">{{message}}</label>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal footer -->
        <!-- Modal footer -->
        <div class="modal-footer text-align-center">
          <button type="button" class="btn btn-secondary modalActionBtn marginright10per" data-dismiss="modal"
            (click)="deleteScenarioByEdit()">{{ 'yes' | translate }}</button>
          <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
            {{ 'no' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- The scenario duplicate error message modal -->
<div class="modal fade" id="duplicateScenarioErrorPopupModelDesigner" data-backdrop="">
  <div class="vertical-alignment-helper">
    <div class="modal-dialog vertical-align-center">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body">
          <div class="row pb-0">
            <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
            <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
              <div class="form-element text-align-center">
                <label class="form-label marginbottom6px">{{duplicateScenario}}</label>
              </div>
              <div class="form-element text-align-center">
                <label class="form-label marginbottom6px">Scenario already exists</label>
              </div>
              <div class="form-element text-align-center">
                <button type="button" class="btn btn-secondary modalActionBtn orgUserListOkbtn pr-0 pl-0"
                  data-dismiss="modal">{{ 'ok' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- The empty scenario add error popup modal -->
<div class="modal fade" id="emptyScenAddErrorPopup" data-backdrop="">
  <div class="vertical-alignment-helper">
    <div class="modal-dialog vertical-align-center">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body">
          <div class="row pb-0">
            <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
            <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
              <div class="form-element text-align-center">
                <label class="form-label marginbottom6px">Scenario can't be empty.</label>
                <!-- <label class="form-label marginbottom6px">{{testDesigner.controller.emptyScenErrMsg}}</label> -->
              </div>
            </div>
          </div>
        </div>
        <!-- Modal footer -->
        <div class="modal-footer text-align-center">
          <!-- <button type="button" class="btn btn-secondary modalActionBtn marginright10per"
              ng-click="openMenu('switch');closeNav()">Yes</button> -->
          <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
            {{ 'ok' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>